/*
 * ParticipantListHead.jsx 30.01.18
 *
 * (c) 2018 ergovia GmbH
 */

import React from 'react';
import {withStyles} from '@material-ui/core/styles';

import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import {SORT_BY_DEADLINE, SORT_BY_GOAL, SORT_BY_NAME, SORT_BY_STEP} from '../../actions/types';


const styles = {
    dateTableCell: {
        borderBottom: 'none'
    },
    rootParticipantName: {
        borderBottom: '0',
        fontSize: '21px',
        textTransform: 'uppercase'
    },
    rootDefault: {
        textAlign: 'center',
        borderBottom: '0',
        fontSize: '21px',
        textTransform: 'uppercase'
    },
    tableSortHeader: {
        '&:after': {
            padding: '0px 10px',
            bottom: -10,
            right: 0,
            position: 'absolute',
            fontSize: '12px',
            content: '""',
            zIndex: 1,
            borderBottom: `2px solid white`,
            width: '100%'
        },
        '&.icon': {
            display: 'none'
        }
    },
    paddingParticipantName: {
        padding: '7px 25px'

    },
    paddingDefault: {
        padding: '7px 0px'

    },
    paddingPlaceholder: {
        padding: '7px 11px'

    }
};

/**
 * Komponente zur Darstellung des Listenkopfes der Teilnehmerliste. Hier steckt die Zeitraumauswahl und die Sortiermöglichkeiten drin
 */
class ParticipantListHead extends React.Component {

    render() {

        const {classes, sort} = this.props;
        const SortHeaderClass = by => by ? classes.tableSortHeader : '';

        return (

            <TableHead>
                <TableRow>
                    <TableCell padding="none" classes={{paddingNone: classes.paddingPlaceholder, root: classes.rootDefault}}>
                        {
                            /* Leere Zeile für Pfeil-Markierung der selektierten Zeile */
                        }
                    </TableCell>
                    <TableCell padding="none" classes={{paddingNone: classes.paddingParticipantName, root: classes.rootParticipantName }}>
                        <TableSortLabel className={SortHeaderClass(sort.by === SORT_BY_NAME)} active={sort.by === SORT_BY_NAME}
                            onClick={() => this.props.onSortChange(SORT_BY_NAME)}>Name, Vorname</TableSortLabel>
                    </TableCell>
                    <TableCell padding="none" classes={{paddingNone: classes.paddingDefault, root: classes.rootDefault}}>
                        <TableSortLabel className={SortHeaderClass(sort.by === SORT_BY_GOAL)} active={sort.by === SORT_BY_GOAL}
                            onClick={() => this.props.onSortChange(SORT_BY_GOAL)}>Ziele</TableSortLabel>
                    </TableCell>
                    <TableCell padding="none" classes={{paddingNone: classes.paddingDefault, root: classes.rootDefault}}>
                        <TableSortLabel className={SortHeaderClass(sort.by === SORT_BY_DEADLINE)} active={sort.by === SORT_BY_DEADLINE}
                            onClick={() => this.props.onSortChange(SORT_BY_DEADLINE)}>Fristen</TableSortLabel>

                    </TableCell>
                    <TableCell padding="none" classes={{paddingNone: classes.paddingDefault, root: classes.rootDefault}}>
                        <TableSortLabel className={SortHeaderClass(sort.by === SORT_BY_STEP)} active={sort.by === SORT_BY_STEP}
                            onClick={() => this.props.onSortChange(SORT_BY_STEP)}>Schritte</TableSortLabel>

                    </TableCell>
                </TableRow>
            </TableHead>
        );
    }
}

export default withStyles(styles)(ParticipantListHead);



// WEBPACK FOOTER //
// ./src/de/ergovia/components/participants/ParticipantListHead.jsx